import classNames from 'classnames';
import React from 'react';

import SemiStore from '@/stores/semi';

import logPrice from './log-price';

export default function SemiList({
  quantityList = [],
  productId,
  recommendSaveTextMap,
  priceListWithLadderLogistic,
  defaultIndex,
  indexSelected,
}: {
  quantityList: PriceTypes.QuantityListItem[];
  priceListWithLadderLogistic: PriceTypes.PriceListWithLadderLogistic;
  productId: number;
  defaultIndex: number;
  recommendSaveTextMap: PriceTypes.RecommendSaveTextMap;
  indexSelected: number;
}) {
  if (quantityList.length < 2) return null;
  const { logisticsList, setPriceIndex } = SemiStore(state => state);
  const renderSavingText = (index: number) => {
    // 无推荐文案不渲染
    if (!recommendSaveTextMap) return null;
    //只有推荐档位渲染savingText
    if (index === defaultIndex) {
      const expressKey = logisticsList[index]?.defaultLogistics;
      return recommendSaveTextMap[expressKey];
    }
    return null;
  };

  const handleClick = (index: number) => {
    const expressKey = logisticsList[index].defaultLogistics;
    logPrice(
      '/sc.detail_pc_halfdelegated_price',
      priceListWithLadderLogistic[index][expressKey],
      'CLK',
      `productId=${productId}`
    );
    setPriceIndex(index);
  };

  return (
    <div className="price-layout">
      <div className="price-list">
        <div
          className="segmented-control__background"
          style={{
            left: `${(100 / quantityList.length) * indexSelected}%`,
            width: `calc(100% / ${quantityList.length})`,
          }}
        ></div>
        {quantityList.map((item, index: number) => (
          <div
            key={index}
            className={classNames({
              'price-item': true,
              activated: indexSelected === index,
            })}
            onClick={() => handleClick(index)}
          >
            <div className="price-grade" title={`${item.text}`}>
              <span>{item.text}</span>
              <span className="recommend-price">{renderSavingText(index)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
